import React from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BookAViewing.css';
import bt from '../../../components/commonStyle.css';
import {
    FormGroup
} from 'react-bootstrap';

import cx from 'classnames';
import * as FontAwesome from 'react-icons/lib/fa';
// Translation
import { injectIntl } from 'react-intl';

// Locale
import messages from '../../../locale/messages';

// Redux
import { connect } from 'react-redux';

// Redux Action
import { bookAViewingOpen } from '../../../actions/bookAViewing/bookAViewingModal';

// Components
import BookAViewingModal from '../BookAViewingModal';

import Loader from '../../Loader';

class BookAViewing extends React.Component {
  static propTypes = {};

  static defaultProps = {};

  constructor(props) {
    super(props);
  }

  render() {
    const { bookAViewingOpen } = this.props;
    const { isLoading } = this.props;
    const { id, userId, hostEmail, city, isOpenOnWeekends } = this.props;
    const { profile: { profileId, displayName, companyName, firstName, lastName, picture, location } } = this.props;
    const { formatMessage } = this.props.intl;

    let loadingStatus = isLoading || false;

    let initialValues = {
      listId: id,
      host: userId,
      hostEmail,
      hostCompanyName: companyName
    };

    return (
        <React.Fragment>
          <BookAViewingModal
            formName={'BookAViewingForm'}
            initialValues={initialValues}
            id={id}
            userId={userId}
            city={city}
            profileId={profileId}
            picture={picture}
            displayName={displayName}
            isOpenOnWeekends={isOpenOnWeekends}
          />
          <div className={cx(s.bookItContainer, 'bookItContentCommon', 'modalMarginTop')} style={{marginTop: '20px'}}>
              <div className={cx(s.bookItContentBox)} data-sticky-section>
                  <div className={cx('bookItFormSection')}>
                      <Loader show={loadingStatus} type={"page"}>
                        <div className={cx(s.bookItPanel, 'borderRadiusNone', 'bookItPanelRtl')}>
                          <FormGroup className={s.formGroup} style={{marginBottom: 0}}>
                            <Loader
                                type={"button"}
                                className={cx(s.btn, s.btnBlock, bt.btnLarge, bt.btnPrimary, 'arButtonLoader', s.requestBtn)}
                                handleClick={() => bookAViewingOpen(id)}
                                disabled={false}
                                show={false}
                                label={formatMessage(messages.bookAViewing)}
                            />
                          </FormGroup>
                        </div>
                      </Loader>
                  </div>
              </div>
          </div>
        </React.Fragment>
    );
  }
}
const mapState = (state) => ({
    isLoading: state.viewListing.isLoading,
});
const mapDispatch = {
  bookAViewingOpen
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(BookAViewing)));


// WEBPACK FOOTER //
// src/components/ViewListing/BookAViewing/BookAViewing.js